module.exports = __webpack_public_path__ + "img/nezam-senfi.25621fc.png";